import '../../css/dots.css';
const Dots = ({ customClass }) => <div className={`dots ${customClass}`}></div>;

export default Dots;
